// extracted by mini-css-extract-plugin
module.exports = {"ChipList":"ChipList_ChipList__1bGuE","Chip":"ChipList_Chip__23e8c","ClearAllButton":"ChipList_ClearAllButton__3Wp1Y"};